<template>
	<div id="app">
		<request-feedback v-if="!visibleFeedback" />
		<common-header v-if="!visibleHeader" />
		<main class="mainbody" v-if="!visibleHeader">
			<keep-alive :include="['PublicNotice']">
				<transition name="el-fade-in" mode="out-in">
					<router-view></router-view>
				</transition>
			</keep-alive>
		</main>
		<router-view v-if="visibleHeader"></router-view>
	</div>
</template>

<script>
import CommonHeader from '@/layouts/Header.vue'
import CommonFooter from '@/layouts/Footer.vue'
import RequestFeedback from '@/components/RequestFeedback'
export default {
	name: 'app',
	components: {
		CommonHeader,
		CommonFooter,
		RequestFeedback
	},
	async created() {
		this.getRoute()
		if (this.visibleHeader) return
		const USER_AGENT = navigator.userAgent.toLowerCase()
		const isChrome = /.*(chrome)\/([\w.]+).*/
		const isEdge = /.*(edge)\/([\w.]+).*/
		const isMobile = USER_AGENT.match(/android|iphone|ipad|ipod|mobile/i)
		const isWechat = USER_AGENT.match(/MicroMessenger/i) == 'micromessenger'
		const isWinXP = USER_AGENT.match(/windows nt 5/)
		const protocolStr = window.location.protocol // 协议
		if (isWinXP && protocolStr === 'https:') {
			// this.$confirm(
			// 	'检测到您在Windows XP系统下使用https加密方式访问本系统。已知XP存在自身问题无法使用https，点击确认为您跳转到非加密http方式。',
			// 	{
			// 		closeOnClickModal: false,
			// 		showClose: false,
			// 		showCancelButton: false,
			// 		title: '温馨提示',
			// 		confirmButtonText: '确认'
			// 	}
			// ).then(() => {
			// 	location.href = 'http:' + window.location.href.substring(protocolStr.length)
			// })
		}
		if (!isChrome.test(USER_AGENT) || isEdge.test(USER_AGENT) || isMobile || isWechat) {
			// this.$confirm(
			// 	'本系统需要使用谷歌浏览器或者与之内核兼容的其他浏览器（如QQ浏览器的极速模式），其他浏览器无法保证完整一致的体验。推荐安装和使用最新版本的谷歌浏览器，点击确认为您打开下载页。',
			// 	{
			// 		closeOnClickModal: false,
			// 		showClose: false,
			// 		title: '温馨提示！不支持的浏览器！',
			// 		confirmButtonText: '去下载安装谷歌浏览器',
			// 		cancelButtonText: '强行继续'
			// 	}
			// )
			// 	.then(() => {
			// 		window.open('https://www.google.cn/intl/zh-CN/chrome/')
			// 	})
			// 	.catch(() => {
			// 		this.forceOn()
			// 	})
		} else if (isChrome.test(USER_AGENT) && parseInt(USER_AGENT.match(/chrome\/([\d.]+)/)[1]) < 60) {
			// this.$confirm(
			// 	'检测到您在使用低版本的谷歌浏览器，请升级到最新版本，才能支持录音，推荐安装和使用最新版本的谷歌浏览器，点击确认为您打开下载页。',
			// 	{
			// 		closeOnClickModal: false,
			// 		showClose: false,
			// 		title: '温馨提示！浏览器版本过低！',
			// 		confirmButtonText: '去下载安装谷歌浏览器',
			// 		cancelButtonText: '强行继续'
			// 	}
			// )
			// 	.then(() => {
			// 		location.href = 'https://www.google.cn/intl/zh-CN/chrome/'
			// 	})
			// 	.catch(() => {
			// 		this.forceOn()
			// 	})
		}
    this.$api.unauthenciatedHandler = err => {
			if (this.$route.name !== 'login') {
				this.$message({
					message: '登录已过期，请重新登录！',
					type: 'error'
				})
        const params = new URLSearchParams(window.top?.location.href)
        const params2 = new URLSearchParams('?' + window.top?.location.href.split('?')[1])
        const token =
          params.get('token') ||
          params2.get('token')?.substring(0, params2.get('token')?.indexOf('#/')) ||
          this.$route.query?.token
        if (token) {
          window.localStorage.removeItem('tokenInfo')
          window.localStorage.removeItem('accountInfo')
          window.localStorage.removeItem('vuex.saved')
          window.localStorage.removeItem('vuex.menu')
          window.localStorage.removeItem('passTip')
          this.$store.commit('removeUserInfo')
          let url = window.location
          window.location.replace(`${url.origin}${url.pathname}`)
        } else {
          const refresh_token = JSON.parse(localStorage.getItem('tokenInfo') || {})?.refresh_token
          if (refresh_token) {
            this.$router.replace('/oneLogin')
          } else {
            this.$router.replace('/login')
          }
        }
			}
		}
	},
	methods: {
		forceOn() {
			// this.$prompt(
			// 	'不支持的浏览器会导致白屏、题目显示不全或者无法录音等问题！如果您依然要继续使用当前浏览器进入，请输入【我已阅读提醒并了解】',
			// 	'请仔细阅读并确认',
			// 	{
			// 		closeOnClickModal: false,
			// 		showClose: false,
			// 		confirmButtonText: '继续进入',
			// 		cancelButtonText: '去安装谷歌浏览器',
			// 		inputValidator: value => {
			// 			return value === '我已阅读提醒并了解'
			// 		},
			// 		inputErrorMessage: '请输入完整正确的确认文字'
			// 	}
			// )
			// 	.then(({ value }) => {
			// 		// do nothing
			// 	})
			// 	.catch(() => {
			// 		location.href = 'https://www.google.cn/intl/zh-CN/chrome/'
			// 	})
		},
		getRoute() {
      const visibleHeaderPaths = ['/exercises', '/execl', '/login', '/oneLogin']
      const visibleFeedbackPaths = ['/exercises', '/execl']
      this.visibleHeader = visibleHeaderPaths.some(path => location.href.includes(path))
      this.visibleFeedback = visibleFeedbackPaths.some(path => location.href.includes(path))
		}
	},
	data() {
		return {
			visibleHeader: false,
      visibleFeedback: false
		}
	},
  watch: {
    '$route'(to, from) {
      this.getRoute()
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/public.scss';

#app {
	// height: 100vh !important;
}
.mainbody {
	width: 100vw;
	//background: #fff;
	// margin: 0 auto;
	// padding-top: 10px;
	//padding-bottom: 40px;
	// height: 100%;
}

.hidden-clear {
	.el-button--text {
		opacity: 0;
		pointer-events: none;
	}
}
.progress-dialog {
  background: transparent !important
}
</style>
